<template>
  <!-- Harvest -->
  <el-collapse-item name="harvest">
    <template #title>
      <div>
        <div class="el-collapse-item__image">
          <img src="./img/harvest-logo.svg" >
        </div>
        <span class="el-collapse-item__title">Harvest</span>
        <span
          class="el-collapse-item__sub-title"
        >A web-based time tracking and invoicing application</span>
      </div>
    </template>
    <div>
      <h4>Track time to Harvest right within DoneDone</h4>
      <p>When Harvest time tracking is enabled, a Harvest timer button will appear inside a {{ itemName }}. Just click the button to start tracking your time.</p>
      <div class="harvest-integration-accordion__form-toggle">
        <el-form
          ref="form"
          :disabled="isSubmitting"
          :model="formData"
          class="harvest-integration-accordion__form-toggle-switch"
        >
          <el-switch v-model="formData.harvestEnabled" />
        </el-form>
        <dd-button
          :is-loading="isSubmitting"
          :color="buttonColor"
          class="harvest-integration-accordion__form-toggle-button float-right"
          size="medium"
          @click="submitHandler"
        >Save Changes</dd-button>
      </div>
    </div>
  </el-collapse-item>
</template>

<script lang="ts">
/* General */
import { defineComponent } from 'vue'

/* Mixins */

/* Components */

/* Helpers */
import TextAssistant from '@/helpers/text-assistant'
import ColorAssistant from '@/helpers/color-assistant'

/* Data types */
import { EEntities } from '@/types'
import {
  IGenericJSONMessage,
  IProjectsOutputIntegrationsHarvestIntegrationInfo,
} from '@/api/types/response.types'

/* API */
import MailboxesAPI from '@/api/modules/mailboxes.api'
import InternalProjectsAPI from '@/api/modules/internal-projects.api'

export default defineComponent({
  name: 'HarvestIntegrationAccordion',

  props: {
    type: {
      type: String as () => EEntities,
      required: true,
    },
    entityId: {
      type: Number,
      required: true,
    },
    harvestIntegration: {
      type: Object as () => IProjectsOutputIntegrationsHarvestIntegrationInfo,
      required: true,
    },
  },

  data() {
    return {
      isSubmitting: false,
      formData: {
        harvestEnabled: false,
      },
    }
  },

  computed: {
    itemName(): string {
      return TextAssistant.itemSingularName(this.type).toLowerCase()
    },

    buttonColor(): string {
      return ColorAssistant.getEntityColor(this.type)
    },
  },

  watch: {
    harvestIntegration: {
      immediate: true,
      handler(newVal) {
        this.formData.harvestEnabled = newVal.enabled
      },
    },
  },

  methods: {
    async save(enabled: boolean): Promise<IGenericJSONMessage> {
      if (this.type === EEntities.MAILBOXES) {
        return await MailboxesAPI.post_SetHarvestEnabled(this.entityId, enabled)
      } else {
        return await InternalProjectsAPI.post_SetHarvestEnabled(
          this.entityId,
          enabled,
        )
      }
    },

    async submitHandler() {
      // @ts-ignore
      this.$refs.form.validate(async valid => {
        if (valid) {
          this.isSubmitting = true
          try {
            const response = await this.save(this.formData.harvestEnabled)
            this.$messaging.showSuccess(response.message)
          } catch (err) {
            this.$error.emit(err, true)
          } finally {
            this.isSubmitting = false
          }
        }
      })
    },
  },
})
</script>

<style lang="scss" scoped>
.harvest-integration-accordion {
  &__form-toggle {
    display: flex;
    align-items: center;
    margin-top: 24px;
    margin-bottom: 24px;
    font-size: 18px;
    font-weight: 500;

    .el-switch {
      margin-right: 7px;
    }
  }

  &__form-toggle-switch {
    max-width: 50%;
  }

  &__form-toggle-button {
    margin-left: auto;
  }
}
</style>
